export class ShipmentAsnSchedule{
    public plant?:string
    public poAgreementNo?:string
    public shipmentDate?:number
    public vendorName?:string
    public scheduleItemNo?:string
    public scheduleQuantity?:string
    public batchNo?:string
    public batchQuantity?:string
    public uom?:string
    public materialCode?:string
    public description_of_material?:string
    public po_line_item?:string
}

export class ShipmentAsn{
    public shipmentNo?:string
    public shipmentAsnScheduleList?:ShipmentAsnSchedule[]
}